export default "__VITE_ASSET__D6Xl07a5__"